import { render, staticRenderFns } from "./Corporation.vue?vue&type=template&id=37e00036&scoped=true&"
import script from "./Corporation.vue?vue&type=script&lang=js&"
export * from "./Corporation.vue?vue&type=script&lang=js&"
import style0 from "./Corporation.vue?vue&type=style&index=0&id=37e00036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e00036",
  null
  
)

export default component.exports